import MenuUnitList, { MenuUnitListProps } from './MenuUnitList';

export type { MenuUnitListProps };
export default MenuUnitList;
